const texts = {
    "withdrawal-banner.body": {
        EN: "b{Withdrawal period:} ${days} days remaining",
        DA: "b{Fortrydelsesret:} ${days} dage tilbage",
        DE: "b{Widerrufsfrist:} noch ${days} Tage",
        NL: "b{Herroepingstermijn:} ${days} dagen resterend",
        FR: "b{Délai de rétractation :} ${days} jours restants",
        IT: "b{Periodo di recesso:} ${days} giorni rimanenti",
        ES: "b{Plazo de desistimiento:} ${days} días restantes",
        PT: "b{Prazo de desistência:} ${days} dias restantes",
        FI: "b{Peruutusaika:} ${days} päivää jäljellä",
        SV: "b{Ångerrätt:} ${days} dagar kvar",
        NO: "b{Angrerett:} ${days} dager igjen",
    },
    "login.header.body": {
        EN: "Enter order details to begin your return or claim process",
        DA: "Indtast ordreoplysninger for at begynde din retur- eller reklamationsproces",
        DE: "Gib deine Bestelldaten ein, um mit der Rückgabe deiner Artikel zu beginnen oder eine Beschwerde einzureichen",
        NL: "Voer uw bestelgegevens in om te starten met de retour- of claimprocedure",
        FR: "Entrez les détails de la commande pour commencer votre processus de retour ou de réclamation",
        IT: "Inserisci i dettagli dell'ordine per iniziare il processo di reso o reclamo",
        ES: "Ingresa los detalles del pedido para comenzar tu proceso de devolución o reclamación",
        PT: "Insira os detalhes do pedido para começar seu processo de devolução ou reclamação",
        FI: "Syötä tilauksen tiedot aloittaaksesi palautus- tai valitusprosessin",
        SV: "Vänligen ange dina orderuppgifter för att påbörja en retur eller skapa en reklamation",
        NO: "Skriv inn ordredetaljene dine for å starte en retur eller reklamasjon",
    },
    "login.header.body.withdrawal": {
        EN: "Enter order details to begin your withdrawal",
        DA: "Indtast ordreoplysninger for at begynde din fortrydelse",
        DE: "Gib deine Bestelldaten ein, um deinen Widerruf zu beginnen",
        NL: "Voer uw bestelgegevens in om uw herroeping te starten",
        FR: "Entrez les détails de la commande pour commencer votre rétractation",
        IT: "Inserisci i dettagli dell'ordine per iniziare il tuo recesso",
        ES: "Ingresa los detalles del pedido para comenzar tu desistimiento",
        PT: "Insira os detalhes do pedido para começar sua desistência",
        FI: "Syötä tilauksen tiedot aloittaaksesi peruutuksen",
        SV: "Ange dina orderuppgifter för att påbörja din ångerrätt",
        NO: "Skriv inn ordredetaljene dine for å starte angreretten",
    },
    "login.header.show-all-orders": {
        EN: "Product Portal",
        DA: "Produktportal",
        DE: "Produktportal",
        NL: "Productportaal",
        FR: "Portail Produits",
        IT: "Portale Prodotti",
        ES: "Portal de Productos",
        PT: "Portal de Produtos",
        FI: "Tuoteportaali",
        SV: "Produktportal",
        NO: "Produktportal",
    },
    "pickup-date.header_body": {
        EN: "Select a shipping method to return your item(s)",
        DA: "Vælg en forsendelsesmetode for at returnere dine varer",
        DE: "Wähle eine Versandmethode, um deine Artikel zurückzusenden",
        NL: "Selecteer een verzendmethode om je artikelen te retourneren",
        FR: "Sélectionnez une méthode d'expédition pour retourner vos articles",
        IT: "Seleziona un metodo di spedizione per restituire i tuoi articoli",
        ES: "Selecciona un método de envío para devolver tus artículos",
        PT: "Selecione um método de envio para devolver seus itens",
        FI: "Valitse palautustapa tuotteidesi palauttamiseen",
        SV: "Välj den metod du vill använda för att returnera dina produkter",
        NO: "Velg metoden du vil bruke for å returnere produktene dine",
    },
    "pickup-date.header_body.withdrawal": {
        EN: "If your order has already shipped, you'll need to send the items back to complete your withdrawal. Choose how you'd like to return them.",
        DA: "Hvis din ordre allerede er afsendt, skal du sende varerne tilbage for at fuldføre din fortrydelse. Vælg, hvordan du vil returnere dem.",
        DE: "Falls deine Bestellung bereits versandt wurde, musst du die Artikel zurücksenden, um deinen Widerruf abzuschließen. Wähle aus, wie du sie zurücksenden möchtest.",
        NL: "Als uw bestelling al is verzonden, moet u de artikelen terugsturen om uw herroeping te voltooien. Kies hoe u ze wilt retourneren.",
        FR: "Si votre commande a déjà été expédiée, vous devrez nous renvoyer les articles pour finaliser votre rétractation. Choisissez votre mode de retour.",
        IT: "Se il tuo ordine è già stato spedito, dovrai rispedirci gli articoli per completare il tuo recesso. Scegli come desideri restituirli.",
        ES: "Si tu pedido ya ha sido enviado, deberás devolvernos los artículos para completar tu desistimiento. Elige cómo prefieres devolverlos.",
        PT: "Se seu pedido já foi enviado, você precisará devolver os itens para concluir sua desistência. Escolha como prefere devolvê-los.",
        FI: "Jos tilauksesi on jo lähetetty, sinun tulee palauttaa tuotteet peruutuksen viimeistelemiseksi. Valitse, miten haluat palauttaa ne.",
        SV: "Om din beställning redan har skickats behöver du returnera varorna för att slutföra din ångerrätt. Välj hur du vill returnera dem.",
        NO: "Hvis bestillingen din allerede er sendt, må du returnere varene for å fullføre angreretten din. Velg hvordan du vil returnere dem.",
    },
    "pickup-date.header_body.with-resale": {
        EN: "Select the method you would like to use for returning your products<br/><br/>b{Note that this only applies to your returns and not your resales}",
        DA: "Vælg den metode, du vil bruge til at returnere dine produkter<br/><br/>b{Bemærk, at dette kun gælder dine returprodukter og ikke dine videresalg}",
        DE: "Wähle die Methode, die du zum Zurücksenden deiner Produkte verwenden möchtest<br/><br/>b{Beachte, dass dies nur für deine Rückgaben gilt und nicht für deine Weiterverkäufe}",
        NL: "Selecteer de methode die je wilt gebruiken om je producten te retourneren<br/><br/>b{Let op: dit geldt alleen voor je retouren en niet voor je doorverkoop}",
        FR: "Sélectionnez la méthode que vous souhaitez utiliser pour retourner vos produits<br/><br/>b{Notez que cela s'applique uniquement à vos retours et non à vos reventes}",
        IT: "Seleziona il metodo che desideri utilizzare per restituire i tuoi prodotti<br/><br/>b{Nota che questo si applica solo ai resi e non alle rivendite}",
        ES: "Selecciona el método que te gustaría usar para devolver tus productos<br/><br/>b{Ten en cuenta que esto aplica solo a tus devoluciones y no a tus reventas}",
        PT: "Selecione o método que você gostaria de usar para devolver seus produtos<br/><br/>b{Observe que isso se aplica apenas aos seus retornos e não às suas revendas}",
        FI: "Valitse menetelmä, jota haluat käyttää tuotteidesi palauttamiseen<br/><br/>b{Huomaa, että tämä koskee vain palautettavia tuotteita eikä jälleenmyyntejä}",
        SV: "Välj den metod du vill använda för att returnera dina produkter<br/><br/>b{Observera att detta endast gäller dina returer och inte dina vidareförsäljningar}",
        NO: "Velg metoden du vil bruke for å returnere produktene dine<br/><br/>b{Vær oppmerksom på at dette kun gjelder returer og ikke videresalg}",
    },
    "return-items.header-body": {
        EN: "Select which item(s) you want to return or claim",
        DA: "Vælg hvilke varer du vil returnere eller reklamere",
        DE: "Wähle aus, welche Artikel du zurückgeben oder reklamieren möchtest",
        NL: "Selecteer welk(e) artikel(en) je wilt retourneren of claimen",
        FR: "Sélectionnez le(s) article(s) que vous souhaitez retourner ou réclamer",
        IT: "Seleziona quale/i articolo/i desideri restituire o reclamare",
        ES: "Selecciona qué artículo(s) quieres devolver o reclamar",
        PT: "Selecione qual(is) item(ns) você deseja devolver ou reclamar",
        FI: "Valitse mitkä tuotteet haluat palauttaa tai reklamoida",
        SV: "Välj de produkter du vill returnera eller reklamera",
        NO: "Velg produktene du ønsker å returnere eller reklamere",
    },
    "return-items.header-body.withdrawal": {
        EN: "All items are included in a withdrawal. Open an item to add a reason.",
        DA: "Alle varer er inkluderet i en fortrydelse. Åbn en vare for at tilføje en begrundelse.",
        DE: "Alle Artikel sind in einem Widerruf enthalten. Öffne einen Artikel, um einen Grund hinzuzufügen.",
        NL: "Alle artikelen zijn opgenomen in een herroeping. Open een artikel om een reden toe te voegen.",
        FR: "Tous les articles sont inclus dans une rétractation. Ouvrez un article pour ajouter un motif.",
        IT: "Tutti gli articoli sono inclusi in un recesso. Apri un articolo per aggiungere un motivo.",
        ES: "Todos los artículos están incluidos en un desistimiento. Abre un artículo para añadir un motivo.",
        PT: "Todos os itens estão incluídos numa desistência. Abra um item para adicionar um motivo.",
        FI: "Kaikki tuotteet sisältyvät peruutukseen. Avaa tuote lisätäksesi syyn.",
        SV: "Alla produkter ingår i en ångerrätt. Öppna en produkt för att lägga till en anledning.",
        NO: "Alle produkter er inkludert i en angrerett. Åpne et produkt for å legge til en grunn.",
    },
    "return-items.header-body.complaints-disabled": {
        EN: "Select which item(s) you want to return",
        DA: "Vælg hvilke varer du vil returnere",
        DE: "Wähle aus, welche Artikel du zurückgeben möchtest",
        NL: "Selecteer welk(e) artikel(en) je wilt retourneren",
        FR: "Sélectionnez le(s) article(s) que vous souhaitez retourner",
        IT: "Seleziona quale/i articolo/i desideri restituire",
        ES: "Selecciona qué artículo(s) quieres devolver",
        PT: "Selecione qual(is) item(ns) você deseja devolver",
        FI: "Valitse mitkä tuotteet haluat palauttaa",
        SV: "Välj de produkter du vill returnera",
        NO: "Velg produktene du ønsker å returnere",
    },
    "return-items.header_body-resale": {
        EN: "Select one item and choose what you want to do.",
        DA: "Vælg en vare og vælg, hvad du vil gøre.",
        DE: "Wähle einen Artikel aus und entscheide, was du tun möchtest.",
        NL: "Selecteer één artikel en kies wat je wilt doen.",
        FR: "Sélectionnez un article et choisissez ce que vous voulez faire.",
        IT: "Seleziona un articolo e scegli cosa vuoi fare.",
        ES: "Selecciona un artículo y elige qué quieres hacer.",
        PT: "Selecione um item e escolha o que você quer fazer.",
        FI: "Valitse yksi tuote ja valitse, mitä haluat tehdä.",
        SV: "Välj en produkt och välj vad du vill göra.",
        NO: "Velg et produkt og hva du vil gjøre.",
    },
    "confirmation-page.header": {
        EN: "Summary",
        DA: "Oversigt",
        DE: "Zusammenfassung",
        NL: "Samenvatting",
        FR: "Résumé",
        IT: "Riepilogo",
        ES: "Resumen",
        PT: "Resumo",
        FI: "Yhteenveto",
        SV: "Sammanfattning",
        NO: "Sammendrag",
    },
    "confirmation-page.header_body": {
        EN: "Review your choices and make sure everything looks good before confirming",
        DA: "Gennemgå dine valg og sørg for, at alt ser godt ud, før du bekræfter",
        DE: "Überprüfe deine Auswahl und stelle sicher, dass alles gut aussieht, bevor du bestätigst",
        NL: "Controleer je keuzes en zorg ervoor dat alles er goed uitziet voordat je bevestigt",
        FR: "Vérifiez vos choix et assurez-vous que tout est correct avant de confirmer",
        IT: "Rivedi le tue scelte e assicurati che tutto sia corretto prima di confermare",
        ES: "Revisa tus elecciones y asegúrate de que todo se vea bien antes de confirmar",
        PT: "Revise suas escolhas e certifique-se de que tudo está correto antes de confirmar",
        FI: "Tarkista valintasi ja varmista, että kaikki näyttää hyvältä ennen vahvistamista",
        SV: "Granska dina val och se till att allt ser bra ut innan du bekräftar",
        NO: "Se gjennom valgene dine og sørg for at alt ser bra ut før du bekrefter",
    },
    "success-page.header": {
        EN: "Your return has been registered",
        DA: "Din retur er blevet registreret",
        DE: "Deine Rückgabe wurde registriert",
        NL: "Je retour is geregistreerd",
        FR: "Votre retour a été enregistré",
        IT: "Il tuo reso è stato registrato",
        ES: "Tu devolución ha sido registrada",
        PT: "Sua devolução foi registrada",
        FI: "Palautuksesi on rekisteröity",
        SV: "Din retur har registrerats",
        NO: "Din retur har blitt registrert",
    },
    "success-page.header.withdrawal": {
        EN: "Your withdrawal has been registered",
        DA: "Din fortrydelse er blevet registreret",
        DE: "Dein Widerruf wurde registriert",
        NL: "Uw herroeping is geregistreerd",
        FR: "Votre rétractation a été enregistrée",
        IT: "Il tuo recesso è stato registrato",
        ES: "Tu desistimiento ha sido registrado",
        PT: "Sua desistência foi registrada",
        FI: "Peruutuksesi on rekisteröity",
        SV: "Din ångerrätt har registrerats",
        NO: "Angreretten din er registrert",
    },
    "success-page.header-claim": {
        EN: "Your claim has been registered",
        DA: "Din reklamation er blevet registreret",
        DE: "Deine Reklamation wurde registriert",
        NL: "Je claim is geregistreerd",
        FR: "Votre réclamation a été enregistrée",
        IT: "Il tuo reclamo è stato registrato",
        ES: "Tu reclamación ha sido registrada",
        PT: "Sua reclamação foi registrada",
        FI: "Valituksesi on rekisteröity",
        SV: "Din reklamation har registrerats",
        NO: "Din reklamasjon har blitt registrert",
    },
    "exchange-success-page.header": {
        EN: "Payment received!",
        DA: "Betaling modtaget!",
        DE: "Zahlung erhalten!",
        NL: "Betaling ontvangen!",
        FR: "Paiement reçu!",
        IT: "Pagamento ricevuto!",
        ES: "¡Pago recibido!",
        PT: "Pagamento recebido!",
        FI: "Maksu vastaanotettu!",
        SV: "Betalning mottagen!",
        NO: "Betaling mottatt!",
    },
    "exchange-failed-page.header": {
        EN: "Payment failed...",
        DA: "Betaling mislykkedes...",
        DE: "Zahlung fehlgeschlagen...",
        NL: "Betaling mislukt...",
        FR: "Paiement échoué...",
        IT: "Pagamento fallito...",
        ES: "Pago fallido...",
        PT: "Pagamento falhou...",
        FI: "Maksu epäonnistui...",
        SV: "Betalningen misslyckades...",
        NO: "Betalingen mislyktes...",
    },
};
export default texts;
